import { useMemo } from 'react';

export const useStepProperties = (steps, currentStep) =>
    useMemo(() => {
        const step = steps[currentStep];
        return {
            isStyleFrame: step?.styleFrame || false,
            showTabNavigation: step?.showTabNavigation || false,
        };
    }, [steps, currentStep]);
